import React from 'react';
import { Swiper, SwiperSlide } from 'swiper/react';
import 'swiper/css';
import 'swiper/css/effect-coverflow';
import 'swiper/css/pagination';
import 'swiper/css/navigation';
import SwiperCore, { EffectCoverflow, Pagination, Navigation } from 'swiper';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faArrowLeft, faArrowRight } from '@fortawesome/free-solid-svg-icons';
import './ImageCarousel.css';

SwiperCore.use([EffectCoverflow, Pagination, Navigation]);

const ImageCarousel = () => {
    const GalleryImages = [
        { src: "/external/images/img1.jpeg" },
        { src: "/external/images/img2.jpeg" },
        { src: "/external/images/img3.jpeg" },
        { src: "/external/images/img4.jpeg" },
        { src: "/external/images/img5.jpeg" },
        { src: "/external/images/img6.jpeg" },
        { src: "/external/images/img7.jpeg" },
        { src: "/external/images/img8.jpeg" },
        { src: "/external/images/img9.jpeg" },
        { src: "/external/images/img10.jpeg" },
        { src: "/external/images/img11.jpeg" },
        { src: "/external/images/img12.jpeg" },
    ];

    return (
        <div className='image-container'>
            <Swiper
                effect={'coverflow'}
                grabCursor={true}
                centeredSlides={true}
                loop={true}
                slidesPerView={'auto'}
                coverflowEffect={{
                    rotate: 0,
                    strech: 0,
                    depth: 100,
                    modifier: 2.5
                }}
                pagination={{ el: '.swiper-pagination', clickable: true }}
                navigation={{
                    nextEl:'.swiper-button-next',
                    prevEl: '.swiper-button-prev',
                    clickable: true
                }}
                modules={[EffectCoverflow, Pagination, Navigation]}
                className='swiper_container'
            >
                {GalleryImages.map((image, index) => (
                    <SwiperSlide key={index}>
                        <img src={image.src} alt={`Campus highlight ${index + 1}`} />
                    </SwiperSlide>
                ))}
                <div className='slider-controler'>
                    <div className='swiper-button-prev slider-arrow'>
                        <FontAwesomeIcon icon={faArrowLeft} />
                    </div>
                    <div className='swiper-button-next slider-arrow'>
                        <FontAwesomeIcon icon={faArrowRight} />
                    </div>
                    <div className='swiper-pagination'></div>
                </div>
            </Swiper>
        </div>
    )
}

export default ImageCarousel;
